// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"279":"89fc6b2f","706":"cf68cdf9","941":"5a616c30"}[chunkId] + ".css";
};